import { render, staticRenderFns } from "./course_file_manage.vue?vue&type=template&id=59047824&scoped=true&"
import script from "./course_file_manage.vue?vue&type=script&lang=js&"
export * from "./course_file_manage.vue?vue&type=script&lang=js&"
import style0 from "./course_file_manage.vue?vue&type=style&index=0&id=59047824&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59047824",
  null
  
)

export default component.exports